import { Container } from "@mui/material";
import { React, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AppDataContext } from "../../../common/appContext";
import {
  RoutePermissions,
  RouteScreens,
} from "../../../common/RoutePermissions";
import { playerCareerStatsService } from "../../../services/playerCareerStatsService";
import { PlayerProfileService } from "../../../services/playerProfile.Service";
import { sportsRadarService } from "../../../services/sportsRadarService";
import PlayerCareerStatsAdvStats from "./playerCareerStatsAdvStats";
import PlayerCareerStatsBasicStats from "./playerCareerStatsBasicStats";
import PlayerCareerStatsReadOnly from "./playerCareerStatsReadOnly";

export default function PlayerCareerStatsContainer(props) {
  const gridSectionStyles = {
    cardStyle: {
      marginTop: "10px",
      boxShadow: "1px 1px 3px grey",
    },
    gridRoot: {
      "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus":
        {
          outline: "none",
        },
    },
    gridConfig: {
      pageSize: 10,
      rowHeight: 38,
      headerHeight: 35,
      autoHeight: true,
    },
    gridSectionTitle: {
      fontWeight: "500",
      color: "#1d428a",
      variant: "subtitle1",
    },
    gridActionButton: {
      marginTop: "15px",
      fontSize: "1.5rem",
      cursor: "pointer",
      color: "#1d428a",
      "&:hover": {
        borderRadius: "50%",
        backgroundColor: "#e4e4e4",
      },
    },
    gridCellClassName: "admin-pref-grid-cells",
    sectionTitlePadding: {
      padding: "10px 0px 0px 15px",
    },
    inputSectionPadding: {
      padding: "10px 15px 0px 15px",
      textAlign: "end",
    },
    dataGridPadding: {
      padding: "15px",
    },
    noRowsOverlay: {
      position: "absolute",
      marginTop: "82px",
      marginLeft: "45%",
    },
    cancelButton: {
      textTransform: "none",
      padding: "2px 2px",
      marginRight: "10px",
      minWidth: "20px !important",
      title: "Cancel",
      variant: "outlined",
      cancelIconColor: {
        color: "#c8102e",
      },
    },
    saveButton: {
      textTransform: "none",
      padding: "2px 2px",
      minWidth: "20px !important",
      title: "Save",
      variant: "contained",
    },
  };
  const ERROR_TEXT = "error";
  const SUCCESS_TEXT = "success";
  const { setLoading, setAlert, setAlertType, setAlertMessage } = props;
  const { user, combineYear, selectedEventId } = useContext(AppDataContext);
  const [canUpdateData, setCanUpdateData] = useState(false);
  const [isEditOn, setIsEditOn] = useState(false);
  const [playerStatsData, setPlayerStasData] = useState({
    playerReadonlyData: null,
    playerBasicStats: [],
    playerAdvStats: [],
  });
  const [basicStatsTemplate, setBasicStatsTemplate] = useState({});
  const [advStatsTemplate, setAdvStatsTemplate] = useState({});
  const params = useParams();

  const StatsType = {
    Basic: 0,
    Adv: 1,
  };

  const DataType = {
    String: 0,
    Numeric: 1,
  };

  useEffect(() => {
    setCanUpdateData(
      RoutePermissions.IsAuthorized(
        RouteScreens.EditCareerStatsOnPlayerProfile,
        user.appRoles
      )
    );
  }, [user]);

  function setupSnackBar(validationMsg, aType, bShowAlert) {
    setAlertMessage(validationMsg);
    setAlertType(aType);
    setAlert(bShowAlert);
  }

  function IsValidData(statsArr, editedRowIndex) {
    let editedArr = { ...statsArr[editedRowIndex] };
    let error = [];
    let sy = editedArr.seasonYear;
    if (!sy) error.push("Season Year is required.");
    else if (sy.toString().trim() == "") error.push("Season Year is required.");
    else {
      let duplicateSY = statsArr.filter(
        (obj, index) => index !== editedRowIndex && obj.seasonYear === sy
      );

      if (duplicateSY.length > 0)
        error.push(`Record for season year ${sy} already exists.`);
    }
    return error.join();
  }

  function anyExistingData(data) {
    return (
      data &&
      data.playerBasicStats &&
      data.playerBasicStats.length > 0 &&
      data.playerBasicStats[0].psId > 0
    );
  }

  function saveTemplate(data) {
    if (data.playerBasicStats && data.playerBasicStats.length > 0) {
      let obj = { ...data.playerBasicStats[0] };
      for (var prop in obj) obj[prop] = null;

      obj["psId"] = 0;
      setBasicStatsTemplate({ ...obj });
    }

    if (data.playerAdvStats && data.playerAdvStats.length > 0) {
      let obj = { ...data.playerAdvStats[0] };
      for (var prop in obj) obj[prop] = null;

      obj["psId"] = 0;
      setAdvStatsTemplate({ ...obj });
    }
  }

  function addObjectProps(arr) {
    let arrCopy = JSON.parse(JSON.stringify(arr));
    arrCopy.forEach((r) => {
      r["isEditMode"] = false;
    });
    return JSON.parse(JSON.stringify(arrCopy));
  }

  async function getPlayerStatsData() {
    try {
      setLoading(true);
      let response = await PlayerProfileService.getPlayerListByCombineYear(
        combineYear,
        params.playerId,
        selectedEventId
      );
      if (response) {
        let data = await response.data;
        if (data) {
          let dataCopy = { ...data };
          dataCopy.playerReadonlyData.combineYear = combineYear;
          saveTemplate(dataCopy);

          if (!anyExistingData(dataCopy)) {
            dataCopy.playerBasicStats = [];
            dataCopy.playerBasicStatsEdit = [];

            dataCopy.playerAdvStats = [];
            dataCopy.playerAdvStatsEdit = [];
          } else {
            if (
              dataCopy.playerReadonlyData.playerID &&
              dataCopy.playerReadonlyData.playerID > 0
            ) {
              if (
                dataCopy.playerBasicStats &&
                dataCopy.playerBasicStats.length > 0
              ) {
                dataCopy.playerReadonlyData.anyPrevPSId =
                  dataCopy.playerBasicStats[0].psId;
              }

              dataCopy.playerBasicStatsEdit = addObjectProps(
                dataCopy.playerBasicStats
              );
              dataCopy.playerAdvStatsEdit = addObjectProps(
                dataCopy.playerAdvStats
              );
            }
          }
          //console.log("datacopy", dataCopy);
          setPlayerStasData({ ...dataCopy });
        }
      }
    } catch (e) {
      console.log("Exception", e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      await getPlayerStatsData();
    })();
  }, [selectedEventId]);

  function SetEditMode(statsType, rowIndex) {
    let playerStatsDataCopy = { ...playerStatsData };
    if (statsType === StatsType.Basic)
      playerStatsDataCopy.playerBasicStatsEdit[rowIndex].isEditMode =
        !playerStatsDataCopy.playerBasicStatsEdit[rowIndex].isEditMode;
    else if (statsType === StatsType.Adv)
      playerStatsDataCopy.playerAdvStatsEdit[rowIndex].isEditMode =
        !playerStatsDataCopy.playerAdvStatsEdit[rowIndex].isEditMode;

    setIsEditOn(
      playerStatsDataCopy.playerBasicStatsEdit[rowIndex].isEditMode ||
        playerStatsDataCopy.playerAdvStatsEdit[rowIndex].isEditMode
    );
    setPlayerStasData({ ...playerStatsDataCopy });
  }

  async function saveBasicStats(rowIndex) {
    let playerStatsDataCopy = { ...playerStatsData };
    let basicStatsArr = JSON.parse(
      JSON.stringify(playerStatsDataCopy.playerBasicStatsEdit)
    );
    let validationMsg = IsValidData(basicStatsArr, rowIndex);
    if (validationMsg === "") {
      let obj = {
        PlayerReadonlyData: { ...playerStatsDataCopy.playerReadonlyData },
        PlayerBasicStats: [basicStatsArr[rowIndex]],
        PlayerAdvStats: null,
      };
      try {
        setLoading(true);
        let response = await playerCareerStatsService.saveStats(obj);
        if (response) {
          let data = await response.data;
          if (data.isSuccess) {
            await getPlayerStatsData();
          }
        }
        setIsEditOn(false);
        //console.log("response-saveBasicStats", response);
        setupSnackBar("Data updated successfully.", SUCCESS_TEXT, true);
      } catch (e) {
      } finally {
        setLoading(false);
      }
    } else {
      setupSnackBar(validationMsg, ERROR_TEXT, true);
    }
  }

  function addNewRowBasicStats() {
    let playerStatsDataCopy = { ...playerStatsData };
    let templateObj = { ...basicStatsTemplate };
    if (
      playerStatsDataCopy.playerBasicStats == null ||
      !Array.isArray(playerStatsDataCopy.playerBasicStats)
    ) {
      playerStatsDataCopy.playerBasicStats = [];
      playerStatsDataCopy.playerBasicStatsEdit = [];
    }
    playerStatsDataCopy.playerBasicStats.push({ ...templateObj });
    playerStatsDataCopy.playerBasicStatsEdit.push({ ...templateObj });

    let rowIndex = playerStatsDataCopy.playerBasicStatsEdit.length - 1;
    playerStatsDataCopy.playerBasicStatsEdit[rowIndex].psId = 0;
    playerStatsDataCopy.playerBasicStatsEdit[rowIndex].isEditMode = true;
    playerStatsDataCopy.playerBasicStatsEdit[rowIndex].isSeasonEditable = true;
    playerStatsDataCopy.playerBasicStatsEdit[rowIndex].isUpdated = false;
    //console.log('addNewRowBasicStats', playerStatsDataCopy);
    setIsEditOn(true);
    setPlayerStasData(JSON.parse(JSON.stringify(playerStatsDataCopy)));
  }

  function UpdateBasicStats(rowIndex, propName, val, dataType, object = {}) {
    const {
      fieldGoalsMade,
      fieldGoalsAtt,
      twoPointsMade,
      twoPointsAtt,
      threePointsMade,
      threePointsAtt,
      freeThrowsMade,
      freeThrowsAtt,
      fieldGoalsPct,
      twoPointsPct,
      threePointsPct,
      freeThrowsPct,
    } = object;

    let playerStatsDataCopy = { ...playerStatsData };
    playerStatsDataCopy.playerBasicStatsEdit[rowIndex][propName] =
      val == "" ? null : dataType == DataType.String ? val : Number(val);

    //#Auto calculate field goal percentage based on bellow formula.
    let iFieldGoalPercentage = fieldGoalsPct || "";
    if (propName === "fieldGoalsMade") {
      iFieldGoalPercentage = ((val / fieldGoalsAtt) * 100) / 100;
    } else if (propName === "fieldGoalsAtt") {
      iFieldGoalPercentage = ((fieldGoalsMade / val) * 100) / 100;
    }

    //#Auto calculate Two Points goal percentage based on bellow formula.
    let iTwoPointsPct = twoPointsPct || "";
    if (propName === "twoPointsMade") {
      iTwoPointsPct = ((val / twoPointsAtt) * 100) / 100;
    } else if (propName === "twoPointsAtt") {
      iTwoPointsPct = ((twoPointsMade / val) * 100) / 100;
    }

    //#Auto calculate Three Points goal percentage based on bellow formula.
    let iThreePointsPct = threePointsPct || "";
    if (propName === "threePointsMade") {
      iThreePointsPct = ((val / threePointsAtt) * 100) / 100;
    } else if (propName === "threePointsAtt") {
      iThreePointsPct = ((threePointsMade / val) * 100) / 100;
    }

    //#Auto calculate Free Throws Points goal percentage based on bellow formula.
    let iFreeThrowsPct = freeThrowsPct || "";
    if (propName === "freeThrowsMade") {
      iFreeThrowsPct = ((val / freeThrowsAtt) * 100) / 100;
    } else if (propName === "freeThrowsAtt") {
      iFreeThrowsPct = ((freeThrowsMade / val) * 100) / 100;
    }

    //#Appened calculated field goal percentage to stats.
    playerStatsDataCopy.playerBasicStatsEdit[rowIndex]["fieldGoalsPct"] =
      iFieldGoalPercentage == ""
        ? null
        : dataType == DataType.String
        ? iFieldGoalPercentage
        : Number(iFieldGoalPercentage);

    playerStatsDataCopy.playerBasicStatsEdit[rowIndex]["twoPointsPct"] =
      iTwoPointsPct == ""
        ? null
        : dataType == DataType.String
        ? iTwoPointsPct
        : Number(iTwoPointsPct);

    playerStatsDataCopy.playerBasicStatsEdit[rowIndex]["threePointsPct"] =
      iThreePointsPct == ""
        ? null
        : dataType == DataType.String
        ? iThreePointsPct
        : Number(iThreePointsPct);

    playerStatsDataCopy.playerBasicStatsEdit[rowIndex]["freeThrowsPct"] =
      iFreeThrowsPct == ""
        ? null
        : dataType == DataType.String
        ? iFreeThrowsPct
        : Number(iFreeThrowsPct);

    setPlayerStasData({ ...playerStatsDataCopy });
  }

  function RevertEntireBasicStatsRow(rowIndex) {
    //console.log(rowIndex);
    let playerStatsDataCopy = { ...playerStatsData };
    if (playerStatsDataCopy.playerBasicStatsEdit[rowIndex].psId == 0) {
      playerStatsDataCopy.playerBasicStatsEdit.splice(rowIndex, 1);
    } else {
      for (var prop in playerStatsDataCopy.playerBasicStats[rowIndex]) {
        playerStatsDataCopy.playerBasicStatsEdit[rowIndex][prop] =
          playerStatsDataCopy.playerBasicStats[rowIndex][prop];
      }
      playerStatsDataCopy.playerBasicStatsEdit[rowIndex]["isEditMode"] = false;
    }

    setPlayerStasData({ ...playerStatsDataCopy });
    setIsEditOn(false);
  }

  async function saveAdvStats(rowIndex) {
    let playerStatsDataCopy = { ...playerStatsData };
    let advStatsArr = JSON.parse(
      JSON.stringify(playerStatsDataCopy.playerAdvStatsEdit)
    );
    let validationMsg = IsValidData(advStatsArr, rowIndex);
    if (validationMsg === "") {
      let obj = {
        PlayerReadonlyData: { ...playerStatsDataCopy.playerReadonlyData },
        PlayerBasicStats: null,
        PlayerAdvStats: [advStatsArr[rowIndex]],
      };
      try {
        setLoading(true);
        let response = await playerCareerStatsService.saveStats(obj);
        if (response) {
          let data = await response.data;
          if (data.isSuccess) {
            await getPlayerStatsData();
          }
        }
        setIsEditOn(false);
        //console.log("response-saveAdvStats", response);
        setupSnackBar("Data updated successfully.", SUCCESS_TEXT, true);
      } catch (e) {
      } finally {
        setLoading(false);
      }
    } else {
      setupSnackBar(validationMsg, ERROR_TEXT, true);
    }
  }

  function addNewRowAdvStats() {
    let playerStatsDataCopy = { ...playerStatsData };
    let templateObj = { ...advStatsTemplate };
    if (
      playerStatsDataCopy.playerAdvStats == null ||
      !Array.isArray(playerStatsDataCopy.playerAdvStats)
    ) {
      playerStatsDataCopy.playerAdvStats = [];
      playerStatsDataCopy.playerAdvStatsEdit = [];
    }
    playerStatsDataCopy.playerAdvStats.push({ ...templateObj });
    playerStatsDataCopy.playerAdvStatsEdit.push({ ...templateObj });

    let rowIndex = playerStatsDataCopy.playerAdvStatsEdit.length - 1;
    playerStatsDataCopy.playerAdvStatsEdit[rowIndex].psId = 0;
    playerStatsDataCopy.playerAdvStatsEdit[rowIndex].isEditMode = true;
    playerStatsDataCopy.playerAdvStatsEdit[rowIndex].isSeasonEditable = true;
    playerStatsDataCopy.playerAdvStatsEdit[rowIndex].isUpdated = false;

    //console.log('addNewRowAdvStats', playerStatsDataCopy);
    setIsEditOn(true);
    setPlayerStasData(JSON.parse(JSON.stringify(playerStatsDataCopy)));
  }

  function UpdateAdvStats(rowIndex, propName, val, dataType) {
    let playerStatsDataCopy = { ...playerStatsData };
    playerStatsDataCopy.playerAdvStatsEdit[rowIndex][propName] =
      val == "" ? null : dataType == DataType.String ? val : Number(val);
    setPlayerStasData({ ...playerStatsDataCopy });
  }

  function RevertEntireAdvStatsRow(rowIndex) {
    let playerStatsDataCopy = { ...playerStatsData };
    if (playerStatsDataCopy.playerAdvStatsEdit[rowIndex].psId == 0) {
      playerStatsDataCopy.playerAdvStatsEdit.splice(rowIndex, 1);
    } else {
      for (var prop in playerStatsDataCopy.playerAdvStats[rowIndex]) {
        playerStatsDataCopy.playerAdvStatsEdit[rowIndex][prop] =
          playerStatsDataCopy.playerAdvStats[rowIndex][prop];
      }
      playerStatsDataCopy.playerAdvStatsEdit[rowIndex]["isEditMode"] = false;
    }
    setPlayerStasData({ ...playerStatsDataCopy });
    setIsEditOn(false);
  }

  function IsRowModified(statsType, rowIndex) {
    let playerStatsDataCopy = { ...playerStatsData };
    let rowEdited = false;
    if (
      statsType === StatsType.Basic &&
      rowIndex < playerStatsDataCopy.playerBasicStats.length
    ) {
      for (var prop in playerStatsDataCopy.playerBasicStats[rowIndex]) {
        if (
          playerStatsDataCopy.playerBasicStats[rowIndex][prop] !=
          playerStatsDataCopy.playerBasicStatsEdit[rowIndex][prop]
        ) {
          rowEdited = true;
          break;
        }
      }
    }
    return rowEdited;
  }

  async function refreshPlayerData(playerId, srPlayerId) {
    try {
      setLoading(true);
      await sportsRadarService.refreshPlayerDetails(
        combineYear,
        playerId,
        srPlayerId,
        user.userID,
        selectedEventId,
        user?.loginID
      );

      await getPlayerStatsData();
      setupSnackBar("Data refreshed successfully.", SUCCESS_TEXT, true);
    } catch (e) {
      setupSnackBar("Data could not be refreshed.", ERROR_TEXT, true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Container maxWidth={false} disableGutters>
      <PlayerCareerStatsReadOnly
        styles={gridSectionStyles}
        data={playerStatsData}
      />
      <PlayerCareerStatsBasicStats
        styles={gridSectionStyles}
        data={playerStatsData.playerBasicStatsEdit}
        readOnlyData={playerStatsData.playerReadonlyData}
        refreshPlayerData={refreshPlayerData}
        SetEditMode={SetEditMode}
        onChange={UpdateBasicStats}
        canUpdateData={canUpdateData}
        isEditOn={isEditOn}
        RevertEntireRow={RevertEntireBasicStatsRow}
        saveStats={saveBasicStats}
        addNewRow={addNewRowBasicStats}
      />
      <PlayerCareerStatsAdvStats
        styles={gridSectionStyles}
        data={playerStatsData.playerAdvStatsEdit}
        SetEditMode={SetEditMode}
        onChange={UpdateAdvStats}
        canUpdateData={canUpdateData}
        isEditOn={isEditOn}
        RevertEntireRow={RevertEntireAdvStatsRow}
        saveStats={saveAdvStats}
        addNewRow={addNewRowAdvStats}
      />
    </Container>
  );
}
